// extracted by mini-css-extract-plugin
module.exports = {"leftButton":"style_leftButton__1ytB3"};